@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="selectionFields inputPanel">
    <div class="inputRow">
      <mat-form-field class="selectionField" [subscriptSizing]="'dynamic'">
        <mat-label>Product Location *</mat-label>
        <mat-select [class.invalidField]="isFieldInvalid('Location')" [(ngModel)]="unitSelectionCriteria.locationId" (selectionChange)="locationChanged()">
          @for (location of locations(); track location) {
            <mat-option [value]="location.id">{{ location.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (families() && families().length > 0) {
        <mat-form-field class="selectionField" [subscriptSizing]="'dynamic'">
          <mat-label>Product Family *</mat-label>
          <mat-select [class.invalidField]="isFieldInvalid('Family')" [(ngModel)]="unitSelectionCriteria.familyId" (selectionChange)="familyChanged()">
            @for (family of families(); track family) {
              <mat-option [value]="family.id">{{ family.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="inputRow">
      @if (systemTypes() && systemTypes().length > 0) {
        <mat-form-field class="selectionField systemTypeInput" [subscriptSizing]="'dynamic'">
          <mat-label>System Type *</mat-label>
          <mat-select [class.invalidField]="isFieldInvalid('SystemType')" [(ngModel)]="unitSelectionCriteria.systemType" (selectionChange)="systemTypeChanged()">
            @for (systemType of systemTypes(); track systemType) {
              <mat-option
                [value]="systemType.code">{{ systemType.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="inputRow">
      @if (motorVoltages() && motorVoltages().length > 0) {
        <mat-form-field class="selectionField" [subscriptSizing]="'dynamic'">
          <mat-label>Unit Power Supply *</mat-label>
          <mat-select [class.invalidField]="isFieldInvalid('PowerSupply')" [(ngModel)]="unitSelectionCriteria.motorVph" (selectionChange)="motorConfigurationChanged()">
            @for (configuration of motorVoltages(); track configuration) {
              <mat-option
                [value]="configuration.description">{{ configuration.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (motorTypes() && motorTypes().length > 0) {
        <mat-form-field class="selectionField" [subscriptSizing]="'dynamic'">
          <mat-label>Motor Type *</mat-label>
          <mat-select [class.invalidField]="isFieldInvalid('MotorType')" [(ngModel)]="unitSelectionCriteria.motorType">
            @for (motorType of motorTypes(); track motorType) {
              <mat-option
                [value]="motorType.motorCode">{{ motorType.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="inputRow">
      @if (availableModels && availableModels.length > 0) {
        <mat-form-field class="selectionField systemTypeInput" [subscriptSizing]="'dynamic'">
          <mat-label>Unit Style</mat-label>
          <mat-select #modelInput (selectionChange)="selectedModelChanged(modelInput.value)"
            panelClass="imageSelectionPanel">
            <mat-option [value]="undefined">
              <span class="imageSelectionValue">
                <img class="selectionImage" src="" alt=""/>
                <label class="selectionLabel">Clear</label>
              </span>
            </mat-option>
            @for (model of availableModels; track model) {
              <mat-option [value]="model">
                <span class="imageSelectionValue">
                  <img class="selectionImage" [src]="model.imageFileName" alt=""/>
                  <label class="selectionLabel">{{ model.description }}</label>
                </span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="inputRow">
      @if (filterTypes() && filterTypes().length > 0) {
        <mat-form-field class="selectionField" [subscriptSizing]="'dynamic'">
          <mat-label>Filter *</mat-label>
          <mat-select [class.invalidField]="isFieldInvalid('Filter')" [(ngModel)]="unitSelectionCriteria.filterType">
            @for (filterType of filterTypes(); track filterType) {
              <mat-option
                [value]="filterType.code">{{ filterType.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <span [matTooltip]="getInvalidReasons()" matTooltipClass="invalidReasonTooltip">
        @if (showCoolingInputs() || showHeatingInputs()) {
          <button class="primary-button" matButton="elevated"
            [disabled]="isBusy() || isInvalid()" (click)="getSelectionCandidates()">
            Get Candidates
          </button>
        }
      </span>
      @if ((showCoolingInputs() || showHeatingInputs()) && isInvalid()) {
        <mat-icon class="warningIcon" color="warn"
          [matTooltip]="getInvalidReasons()" matTooltipClass="invalidReasonTooltip">warning
        </mat-icon>
      }
    </div>
  </div>
  @if (showCoolingInputs() || showHeatingInputs()) {
    <div class="inputPanel">
      <div class="inputRow">
        @if (!showFanSpeedInput()) {
          <mat-form-field [class.invalidField]="isFieldInvalid('Airflow')" class="conditionField" [subscriptSizing]="'dynamic'">
            <mat-label>{{ 'Airflow (' + getAirflowUnits() + ')' }}</mat-label>
            <input matInput type="number" [(ngModel)]="unitSelectionCriteria.airflow" [required]="!showFanSpeedInput()"/>
          </mat-form-field>
        }
        <mat-form-field class="conditionField" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'Altitude (' + getLengthUnits() + ') *' }}</mat-label>
          <input [class.invalidField]="isFieldInvalid('Altitude')" matInput type="number" [(ngModel)]="unitSelectionCriteria.altitude"/>
        </mat-form-field>
        <mat-form-field class="conditionField" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'ESP (' + getEspUnits() + ') *' }}</mat-label>
          <input [class.invalidField]="isFieldInvalid('ESP')" matInput type="number" [(ngModel)]="unitSelectionCriteria.externalStaticPressure"/>
        </mat-form-field>
        <mat-checkbox class="conditionField" (change)="metricInputChanged()"
          [(ngModel)]="unitSelectionCriteria.metricInput">
          Metric Input
        </mat-checkbox>
      </div>
      <div class="inputRow">
        <mat-form-field class="conditionField" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'Width (' + getDimensionalUnits() + ')' }}</mat-label>
          <input matInput [(ngModel)]="unitSelectionCriteria.maxWidth"/>
        </mat-form-field>
        <mat-form-field class="conditionField" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'Height (' + getDimensionalUnits() + ')' }}</mat-label>
          <input matInput [(ngModel)]="unitSelectionCriteria.maxHeight"/>
        </mat-form-field>
        <mat-form-field class="conditionField" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'Length (' + getDimensionalUnits() + ')' }}</mat-label>
          <input matInput [(ngModel)]="unitSelectionCriteria.maxLength"/>
        </mat-form-field>
      </div>
      <div class="inputRow">
        @if (showFanSpeedInput()) {
          <mat-form-field class="selectionField" [subscriptSizing]="'dynamic'">
            <mat-label>Fan Speed</mat-label>
            <mat-select [(ngModel)]="unitSelectionCriteria.fanSpeedCode">
              <mat-option [value]="'H'">High</mat-option>
              <mat-option [value]="'M'">Medium</mat-option>
              <mat-option [value]="'L'">Low</mat-option>
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field class="selectionField" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'Max Pressure Drop (' + getPressureUnits() + ')' }}</mat-label>
          <input type="number" matInput [(ngModel)]="unitSelectionCriteria.pressureDrop"/>
        </mat-form-field>
      </div>
      <div class="inputRow">
        @if (showCoolingInputs()) {
          <div class="inputPanel">
            <app-cooling-performance-inputs [criteria]="unitSelectionCriteria.coolingCriteria" [fluidTypes]="fluidTypes()" [airflow]="unitSelectionCriteria.airflow"
              [metricInput]="unitSelectionCriteria.metricInput" [isRefrigerant]="isRefrigerant()" [conditionLimits]="conditionLimits()" [invalidCapacity]="isFieldInvalid('CoolingTargetValue')">
            </app-cooling-performance-inputs>
          </div>
        }
        @if (showHeatingInputs()) {
          <div class="inputPanel">
            <app-heating-performance-inputs [criteria]="unitSelectionCriteria.heatingCriteria" [fluidTypes]="fluidTypes()"
              [metricInput]="unitSelectionCriteria.metricInput" [isSteam]="isSteam()" [airflow]="unitSelectionCriteria.airflow"
              [showHydronicHeating]="showHydronicHeating()" [conditionLimits]="conditionLimits()" [invalidCapacity]="isFieldInvalid('HeatingTargetValue')">
            </app-heating-performance-inputs>
          </div>
        }
      </div>
    </div>
  }
  @if (resultMessage()) {
    <div class="resultMessage">{{ resultMessage() }}</div>
  }
  @if (candidates() && candidates().length > 0) {
    <div class="resultsGrid">
      <app-selection-candidate-grid [candidates]="candidates()" (addedToSchedule)="addToUnitList($event)"
        [metricInput]="unitSelectionCriteria.metricInput" [notice]="getProjectNotice()">
      </app-selection-candidate-grid>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait</label>
    </div>
  </div>
}
